import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { requestLogin, logout } from '../actions';

class Header extends Component {
  constructor(props) {
    super(props);
    this.handleLogoutClick = this.handleLogoutClick.bind(this);
  }

  componentDidMount() {
    if (sessionStorage.getItem('spasts_token') !== null) {
      this.props.dispatch(requestLogin(sessionStorage.getItem('spasts_token')));
    }
  }

  handleLogoutClick() {
    this.props.dispatch(logout());
  }

  renderAuthenticationButtons() {
    const SP_URL = window.configuration.spUrl;
    const SP_RESPONSE_TYPE = window.configuration.sp_response_type;
    const SP_REDIRECT_URI = window.configuration.sp_redirectUri;
    const CLIENT_ID = window.configuration.sp_clientId;
    const SP_SCOPE = window.configuration.sp_scope;
    const SP_STATE = window.configuration.sp_state;
    const SP_CLIENT_ID = window.configuration.sp_clientId;
    const SP_IDENTITY_CUSTOMER =
      window.configuration.sp_identity_provider_customer;
    const SP_IDENTITY_INTERNAL =
      window.configuration.sp_identity_provider_internal;

    const { user } = this.props;

    const LOGIN_URL_CUSTOMER = `${SP_URL}?response_type=${SP_RESPONSE_TYPE}&idp1&scope=${SP_SCOPE}&state=${SP_STATE}&client_id=${SP_CLIENT_ID}&identity_provider=${SP_IDENTITY_CUSTOMER}&redirect_uri=${SP_REDIRECT_URI}`;
    const LOGIN_URL_INTERNAL = `${SP_URL}?response_type=${SP_RESPONSE_TYPE}&idp2&scope=${SP_SCOPE}&state=${SP_STATE}&client_id=${SP_CLIENT_ID}&identity_provider=${SP_IDENTITY_INTERNAL}&redirect_uri=${SP_REDIRECT_URI}`;

    //ValmetADFS
    if (user === undefined) {
      return (
        <ul className="nav navbar-nav pull-right">
          <li>
            <a href={`${LOGIN_URL_CUSTOMER}`}>Customer Login</a>
          </li>
          <li>
            <a href={`${LOGIN_URL_INTERNAL}`}>Valmet Internal Login</a>
          </li>
        </ul>
      );
    } else {
      return (
        <ul className="nav navbar-nav navbar-right">
          <li>
            <div className="navbar-brand">{user.user_id}</div>
          </li>
          <li className="active">
            <button className="navbar-logout" onClick={this.handleLogoutClick}>
              Logout
            </button>
          </li>
        </ul>
      );
    }
  }

  render() {
    const { fetching, user, loginFailure, activepage } = this.props;
    //console.log(this.props);

    return (
      <div className={activepage + ' navbar navbar-default'}>
        <div className="container">
          <div className="navbar-header">
            <img src="/images/Valmet_logo.png" className="logo" />
            <div className={(!fetching && 'hidden') || 'cssload-container'}>
              <div className="cssload-whirlpool"></div>
            </div>
            <button
              type="button"
              className="navbar-toggle"
              data-toggle="collapse"
              data-target=".navbar-collapse"
            >
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <span className="navbar-brand" href="#">
              Production and Energy Survey
            </span>
          </div>

          <div className="collapse navbar-collapse">
            <ul className="nav navbar-nav">
              <li className="active">
                <Link to={'/'}>My surveys</Link>
              </li>
            </ul>
            {this.renderAuthenticationButtons()}
            <ul className="nav navbar-nav pull-right">
              <li>
                <Link to={'/'}>
                  {user === undefined && loginFailure !== undefined
                    ? 'Login error: ' + loginFailure
                    : ''}
                </Link>
                <Link to={'/'}>{user === undefined ? '' : user.username}</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className={activepage + ' container header-background'}>
          &nbsp;
          <h1>Production and Energy</h1>
          <h2 className="h2-subtitle">Survey</h2>
        </div>
      </div>
    );
  }
}

Header.propTypes = {};

function mapStateToProps(state) {
  const { user } = state;
  return {
    user: user.user,
    loginFailure: user.loginFailure,
  };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/Header.js